module.exports = __webpack_public_path__ + "img/headingEle.254ecb50.svg";